import { render, staticRenderFns } from "./PCS.vue?vue&type=template&id=1f955bab&scoped=true"
import script from "./PCS.vue?vue&type=script&lang=js"
export * from "./PCS.vue?vue&type=script&lang=js"
import style0 from "./PCS.vue?vue&type=style&index=0&id=1f955bab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f955bab",
  null
  
)

export default component.exports